import { RouteNames } from '@/data/routes';

import EmailVerificationPage from '@/pages/email-verification/EmailVerificationPage.vue';
import { createRoutes } from '@/utils/router-helper';

export default createRoutes({
  path: '/email-verification',
  name: RouteNames.EMAIL_VERIFICATION.INDEX,
  component: EmailVerificationPage,
});
